import { gradeFromGradYear } from "@/utils/gradeFromGradYear";
import type { MissingStudentRow } from "../../components/dashboard/MissingEnrollment/MissingEnrollmentDataTable";
import type { MissingEnrollmentSession } from "../../pages/Dashboard";

export const buildRows = (
  sessions: MissingEnrollmentSession[],
): {
  missingEnrollmentRows: MissingStudentRow[];
  missingPreferencesRows: MissingStudentRow[];
} => {
  const missingEnrollmentRows: MissingStudentRow[] = [];
  const missingPreferencesRows: MissingStudentRow[] = [];

  for (const s of sessions) {
    for (const student of s.missingEnrollments) {
      missingEnrollmentRows.push({
        sessionId: s._id,
        sessionName: s.name,
        studentId: student._id,
        studentName: student.name,
        studentGradeLevel: gradeFromGradYear(student.gradYear),
      });
    }
    for (const student of s.missingPreferences) {
      missingPreferencesRows.push({
        sessionId: s._id,
        sessionName: s.name,
        studentId: student._id,
        studentName: student.name,
        studentGradeLevel: gradeFromGradYear(student.gradYear),
      });
    }
  }

  return { missingEnrollmentRows, missingPreferencesRows };
};
